import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import { request } from "@/js/http/http_request";
export default {
  name: "OrderHistoryDrawer",
  components: {},
  props: {
    isShown: Boolean,
    order: Object
  },
  data: function data() {
    return {
      gettingHistories: {
        isPending: false,
        cancellationToken: null,
        items: []
      }
    };
  },
  computed: {},
  created: function created() {
    this.fetchHistory();
  },
  methods: {
    open: function open() {},
    close: function close() {
      this.$emit("close");
    },
    fetchHistory: function fetchHistory() {
      var delayed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (process.env.NODE_ENV == "production") {
        this.gettingHistories.isPending = true;
        var _this = this;
        setTimeout(function () {
          request("/audit-trail?OrderId=".concat(_this.order.id_order), "get", null, true, "api").then(function (response) {
            _this.gettingHistories.items = _toConsumableArray(response.data);
            _this.gettingHistories.isPending = false;
          });
        }, delayed ? 10 * 1000 : 0);
      }
    },
    boldQuotedText: function boldQuotedText(message) {
      return message.replace(/"([^"]*)"/g, "<strong>$1</strong>").replace(new RegExp("(".concat(this.order.id_order, ")"), "g"), "<strong>$1</strong>");
    }
  }
};